import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import { firestorePlugin } from 'vuefire'
import VueClipboard from 'vue-clipboard2'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import { faCalendarWeek } from '@fortawesome/free-solid-svg-icons'
import { faRunning } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'

import JsonCSV from 'vue-json-csv'

Vue.use(firestorePlugin)

Vue.component('downloadCsv', JsonCSV)

library.add(faUsers, faBuilding, faCalendarWeek, faRunning, faCog, faStar)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueClipboard)

Vue.use(firestorePlugin)

Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } })

Vue.use(Notifications)

Vue.config.productionTip = false

let app = null;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!firebase.auth().currentUser) {
      router.push('/');
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    await store.dispatch('getCoachDoc', user.uid);
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})